import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import userweb from "../../assets/images/icon_home/user.svg";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import Company from "../../core/models/company";
import User from "../../core/models/user";

import bsi from "../../assets/images/icon_topup/bsi.svg";
import Alfa from "../../assets/images/icon_topup/Alfa.svg";
import bankJatim from "../../assets/images/icon_topup/bankJatim.svg";
import bankntb from "../../assets/images/icon_topup/bankntb.svg";
import bankntbsy from "../../assets/images/icon_topup/bankntbsy.svg";
import bca from "../../assets/images/icon_topup/bca.svg";
import bjb from "../../assets/images/icon_topup/bjb.png";
import bnis from "../../assets/images/icon_topup/bnis.svg";
import bri from "../../assets/images/icon_topup/bri.svg";
import btpn from "../../assets/images/icon_topup/btpn.svg";
import bsb from "../../assets/images/icon_topup/bsb.svg";
import bsbs from "../../assets/images/icon_topup/bsbs.svg";
import cimb from "../../assets/images/icon_topup/cimb.svg";
import cimbsyariah from "../../assets/images/icon_topup/cimbsyariah.png";
import dana from "../../assets/images/icon_topup/dana.svg";
import danamon from "../../assets/images/icon_topup/danamon.svg";
import indo from "../../assets/images/idnassets/merchant/indomaret.png";
import linkaja from "../../assets/images/icon_topup/linkaja.svg";
import mandiri from "../../assets/images/icon_topup/mandiri.svg";
import maybank from "../../assets/images/icon_topup/maybank.svg";
import muamalat from "../../assets/images/icon_topup/muamalat.svg";
import nobu from "../../assets/images/icon_topup/nobu.svg";
import ocbc from "../../assets/images/icon_topup/ocbc.svg";
import bjbs from "../../assets/images/icon_topup/bjbs.svg";
import xendit from "../../assets/images/icon_topup/xendit.svg";
import ovo from "../../assets/images/icon_topup/ovo.svg";
import permatasyariah from "../../assets/images/icon_topup/permatasyariah.svg";
import shopee from "../../assets/images/icon_topup/shopee.svg";
import bjs from "../../assets/images/icon_topup/bjs.svg";
import kbbs from "../../assets/images/icon_topup/kbbs.png";
import idn from "../../assets/images/icon_topup/idn.svg";
import bni from "../../assets/images/icon_topup/bni.svg";
import permata from "../../assets/images/icon_topup/permata.svg";
import bntb from "../../assets/images/icon_topup/bntb.svg";
import gojek from "../../assets/images/idnassets/merchant/gopay.png";
import tokped from "../../assets/images/idnassets/merchant/tokopedia.png";
import blibli from "../../assets/images/idnassets/merchant/blibli.png";
import bayarind from "../../assets/images/idnassets/merchant/bayarind.png";
import kaspro from "../../assets/images/idnassets/merchant/kaspro.png";
import Ayopop from "../../assets/images/idnassets/merchant/ayopop.png";
import mobilepulsa from "../../assets/images/idnassets/merchant/mobilepulsa.png";
import tkiLogo from "../../assets/images/logo-company.svg";

import { Stats, StatsProfil, StatsTopup } from "../common/home/Stats";

import { toast } from "react-toastify";
import {
  createVa,
  getAllCreatedVa,
  paymentIdn,
} from "../../core/service/api_topup";
import _, { bind, create } from "lodash";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import { useDispatch } from "react-redux";
import { setUser } from "../../core/feature/user/userSlice";
import { Dialog, Transition } from "@headlessui/react";
import CustomApp from "../../core/models/customApp";
import { formatCurrency } from "../../config/global";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { isDarkColor } from "../../config/DarkColorChecker";
import CurrencyInput from "react-currency-input-field";
import {
  getBankDisplayIcon,
  getBankDisplayName,
  sortTopupBanks,
} from "./topupBankUtils";

const ComponentTopupWeb = () => {
  const location = useLocation();
  const { cid } = useParams();
  const [menua, setMenua] = useState(false);
  const [menub, setMenub] = useState(false);
  const [menuc, setMenuc] = useState(false);
  const [menud, setMenud] = useState(false);
  const user: User = useAppSelector((state) => state.user.user);
  let company = JSON.parse(String(localStorage.getItem("company")));
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  let [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const [menue, setMenue] = useState(false);
  const [pathName, setPathName] = useState(
    location.pathname.replaceAll("/", "").toUpperCase(),
  );
  const [data, setData] = useState<any>({});
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const [tutor, setTutor] = useState<any>({});

  let [openInputAmount, setOpenInput] = useState(false);
  const [amount, setAmount] = useState(0);
  const [succesCreate, setSuccesCreate] = useState(false);
  const [idn, setIdn] = useState(false);
  const [tempMetode, setTempMetode] = useState<any>({});
  const [imagePreview, setImagePreview] = useState<any>();
  const [openPreview, setopenPreview] = useState(false);
  const [errAmount, setErrAmount] = useState("");

  const [idnVa, setIdnVa] = useState<any>({});
  const topUpIdn = [
    {
      active: false,
      name: "Indomaret",
      image: indo,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cashier.png"),
          name: "LANGKAH 1 PAYMENT POINT",
          information:
            "Informasikan kepada kasir akan melakukan pembayaran Payment Point",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_select.png"),
          name: "LANGKAH 2 VALIDASI",
          information:
            "Sebutkan Nama Sekolah dan Nomor Induk Siswa Anda kepada kasir.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cards.png"),
          name: "LANGKAH 3 PEMBAYARAN",
          information:
            "Detail tagihan akan ada pada layar Kasir. Lakukan pembayaran ke Kasir sejumlah nominal yang disebutkan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_receipt.png"),
          name: "LANGKAH 4 SELESAI",
          information:
            "Anda akan menerima struk pembayaran sebagai bukti transaksi berhasil. Notifikasi pembayaran juga akan langsung diterima oleh Institusi Pendidikan",
        },
      ],
    },
    {
      active: true,
      name: "Alfamart",
      image: Alfa,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cashier.png"),
          name: "LANGKAH 1 INFORMASI",
          information:
            "Informasikan kepada kasir akan melakukan pembayaran Jaringan IDN, kemudian sebutkan Kode IDN dan NIS (Nomor Induk Siswa / Mahasiswa). replaceBranchCode replaceNis",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_select.png"),
          name: "LANGKAH 2 VALIDASI",
          information:
            "Pastikan data yang kasir informasikan valid dan total tagihan benar.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_cards.png"),
          name: "LANGKAH 3 PEMBAYARAN",
          information:
            "Bayar sejumlah nominal dengan menggunakan tunai atau non tunai.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/indomaret/icon_doc_receipt.png"),
          name: "LANGKAH 4 SELESAI",
          information:
            "Anda akan menerima struk pembayaran sebagai bukti transaksi berhasil.",
        },
      ],
    },

    {
      active: true,
      name: "Gopay",
      image: gojek,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen01.png"),
          name: "LANGKAH 1 PILIH GO-BILLS",
          information: "Pada aplikasi Gojek, pilih menu GO-BILLS",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen02.png"),
          name: "LANGKAH 2 PILIH MENU SEKOLAH",
          information: "Di halaman GO-BILLS,pilih menu Schools.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen03.png"),
          name: "LANGKAH 3 CARI SEKOLAH",
          information: "Gunakan Institusi TKI(Teknologi Kartu Indonesia)",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/gopay/gopay_screen05.png"),
          name: "LANGKAH 4 MASUKAN NIS/NIM",
          information: "Masukan NIS/NIM Anda replaceNis pada kolom ID Pelajar.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen06.png"),
          name: "LANGKAH 5 KONFIRMASI",
          information:
            "Pastikan data tagihan sudah benar, lalu lakukan pembayaran dengan GO-PAY.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/gopay/gopay_screen07.png"),
          name: "LANGKAH 6 SELESAI",
          information:
            "Pembayaran Selesai. Anda dapat menyimpan atau mengirimkan bukti pembayaran dengan menekan tombol Send Receipt.",
        },
      ],
    },
    {
      active: true,
      name: "Tokopedia",
      image: tokped,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen01.png"),
          name: "LANGKAH 1 PILIH TOPUP & TAGIHAN",
          information: "Pada aplikasi Tokopedia,pilih menu Topup & Tagihan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen02.png"),
          name: "LANGKAH 2 PILIH BIAYA PENDIDIKAN",
          information:
            "Di halaman Topup & Tagihan,pilih menu Biaya Pendidikan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen03.png"),
          name: "LANGKAH 3 PILIH JENIS LEMBAGA PENDIDIKAN",
          information: "Pilih Cluster yang terdiri dari Kursus.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen04.png"),
          name: "LANGKAH 4PILIH INSTITUSI",
          information:
            "Pilih Institusi TKI(Teknologi Kartu Indonesia) pada kolom operator.",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen05.png"),
          name: "LANGKAH 5 MASUKAN NIS/NIM",
          information:
            "Masukkan NIS/NIM replaceNis pada Nomor Pembayaran / Nomor Mahasiswa lalu klik cek tagihan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/tokopedia/toped_screen06.png"),
          name: "LANGKAH 6 KONFIRMASI",
          information:
            "Pastikan data tagihan sudah benar serta Ikuti langkah pembayaran dari akun Tokopedia Anda.",
        },
      ],
    },
    {
      active: true,
      name: "Blibli",
      image: blibli,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen01.png"),
          name: "LANGKAH 1 MENU PENDIDIKAN",
          information: "Pada aplikasi/web Blibli, pilih menu Pendidikan",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen02.png"),
          name: "LANGKAH 2 TIPE PILIH INSTITUSI",
          information:
            "Di halaman Pendidikan, pilih Nama Institusi TKI (Teknologi Kartu Indonesia)",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen03.png"),
          name: "LANGKAH 3 MASUKAN NIS/NIM",
          information:
            "Tagihan akan muncul setelah memasukan NIS/NIM replaceNis.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen03.png"),
          name: "LANGKAH 4 KONFIRMASI",
          information:
            "Periksa kembali semua data tagihan yang muncul sebelum lanjut ke pembayaran.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/Blibli/bli2_screen05.png"),
          name: "LANGKAH 5 METODE PEMBAYARAN",
          information:
            "Pilih metode pembayaran yang Anda inginkan, lalu klik tombol “Bayar Sekarang.",
        },
      ],
    },
    // {
    //   "active": false,
    //   "name": "Bayarind",
    //   "image": bayarind,
    //   "children": [
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen01.png"),
    //       "name": "LANGKAH 1 PILIH SEE ALL",
    //       "information": "Pada aplikasi Bayarind pilih menu “See All”."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen02.png"),
    //       "name": "LANGKAH 2 PILIH MENU EDUKASI",
    //       "information": "Pada halaman Category, pilih “Edukasi”"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen03.png"),
    //       "name": "LANGKAH 3 PILIH SEKOLAH",
    //       "information": "Pilih Institusi Pendidikan yang anda tuju."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen04.png"),
    //       "name": "LANGKAH 4 MASUKAN NIS/NIM",
    //       "information": "Lalu masukan NIS/NIM pada kolom yang tersedia."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen05.png"),
    //       "name": "LANGKAH 5 PILIH TAGIHAN",
    //       "information": "Anda dapat memilih seluruh tagihan atau pilih yang ingin Anda bayarkan."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen06.png"),
    //       "name": "LANGKAH 6 KONFIRMASI",
    //       "information": "Pastikan total tagihan (berikut admin fee) yang ingin anda bayarkan sudah sesuai."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen07.png"),
    //       "name": "LANGKAH 7 METODE PEMBAYARAN",
    //       "information": "Anda dapat memilih metode pembayaran dengan Bayarind atau Oneklik."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen08.png"),
    //       "name": "LANGKAH 8 PIN",
    //       "information": "Masukan PIN dan akan otomatis ke pembayaran."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/bayarindo/bayarind_screen09.png"),
    //       "name": "LANGKAH 9 SELESAI",
    //       "information": "Pembayaran Selesai"
    //     }
    //   ]
    // },
    // {
    //   "active": false,
    //   "name": "Kaspro",
    //   "image": kaspro,
    //   "children": [
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen01.png"),
    //       "name": "LANGKAH 1 PILIH MENU PEMBAYARAN",
    //       "information": "Setelah men-download aplikasi, lakukan login, dan pilih Bill & Voucher"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen02.png"),
    //       "name": "LANGKAH 2 PILIH MENU SEKOLAH",
    //       "information": "Kemudian pilih menu School."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen03.png"),
    //       "name": "LANGKAH 3 DETIL SISWA",
    //       "information": "Masukan Kode Sekolah pada kolom IDN Code (lihat disini) dan Nomor Induk Siswa"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen04.png"),
    //       "name": "LANGKAH 4 PILIH TAGIHAN",
    //       "information": "Setelah muncul tagihan siswa, Anda dapat memilih tagihan yang ingin dibayarkan. Lalu klik Next."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen05.png"),
    //       "name": "LANGKAH 5 KONFIRMASI TAGIHAN",
    //       "information": "Pastikan data tagihan yang muncul sudah sesuai."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen06.png"),
    //       "name": "LANGKAH 6 KEAMANAN TRANSAKSI",
    //       "information": "Untuk keamanan bertransaksi, Anda harus memasukan PIN yang diminta oleh aplikasi."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen07.png"),
    //       "name": "LANGKAH 7 SELESAI",
    //       "information": "Transaksi selesai. Anda dapat menyimpan bukti pembayaran."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/kaspro/kaspro_screen08.png"),
    //       "name": "LANGKAH 8 NOTIFIKASI",
    //       "information": "Selain bukti transaksi di dalam aplikasi, anda juga akan mendapatkan notifikasi SMS."
    //     }
    //   ]
    // },
    {
      active: false,
      name: "Ayopop",
      image: Ayopop,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen01.png"),
          name: "LANGKAH 1 PILIH MENU PENDIDIKAN",
          information:
            "Setelah men-download aplikasi, lakukan login, dan pilih Pendidikan (download di Google Play atau App Store)",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen02.png"),
          name: "LANGKAH 2 PILIH SEKOLAH",
          information: "Kemudian pilih menu School.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen03.png"),
          name: "LANGKAH 3 MASUKAN NIS/NIM",
          information: "Masukan Nomor Induk Siswa Anda",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen04.png"),
          name: "LANGKAH 4 TAGIHAN",
          information:
            "Setelah muncul tagihan siswa klik LANJUT KE PEMBAYARAN.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen05.png"),
          name: "LANGKAH 5 PILIH METODE PEMBAYARAN",
          information:
            "Pilih metode pembayaran yang anda inginkan (Transfer, Kredit, Retail, Virtual Account, e-Cash).",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/ayopop/ayopop_screen06.png"),
          name: "LANGKAH 6 SELESAI",
          information: "Simpan bukti pembayaran anda.",
        },
      ],
    },
    // {
    //   "active": false,
    //   "name": "Mobilepulsa",
    //   "image": mobilepulsa,
    //   "children": [
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay1.png"),
    //       "name": "LANGKAH 1 PILIH MENU",
    //       "information": "Pilih menu Tagihan, lalu pilih menu Pendidikan."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay2.png"),
    //       "name": "LANGKAH 2 KONFIRMASI",
    //       "information": "Kemudian pilih Sekolah Anda dan masukan NIS Anda."
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay3.png"),
    //       "name": "LANGKAH 3 PEMBAYARAN",
    //       "information": "Halaman Ringkasan ditampilkan, pilih tagihan yang akan dibayarkan. Ikut petunjukan untuk melakukan pembayaran"
    //     },
    //     {
    //       "copy": false,
    //       "image": require("../../assets/images/idnassets/mobilepulsa/icon_doc_pay4.png"),
    //       "name": "LANGKAH 4 SELESAI",
    //       "information": "Setelah selesai, Anda bisa Cek Notifikasi atau Download Struk."
    //     }
    //   ]
    // },
    {
      active: true,
      name: "Shopee",
      image: shopee,
      children: [
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen01.png"),
          name: "LANGKAH 1 BUKA APLIKASI Shopee",
          information:
            "Pada aplikasi shopee, pilih menu Pulsa, Tagihan & Hiburan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen02.png"),
          name: "LANGKAH 2 LIHAT BAGIAN TAGIHAN",
          information: "Pada bagian Bills, pilih menu BIAYA PENDIDIKAN.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen03.png"),
          name: "LANGKAH 3 PILIH INSTITUSI",
          information: "Tekan Pilih Institusi.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen04.png"),
          name: "LANGKAH 4 CARI INSTITUSI",
          information: "Gunakan Institusi TKI (Teknologi Kartu Indonesia)",
        },
        {
          copy: true,
          image: require("../../assets/images/idnassets/shopee/shopee_screen05.png"),
          name: "LANGKAH 5 MASUKAN NOMOR PEMBAYARAN",
          information: "Masukkan Nomor Pembayaran atau Nomor Siswa replaceNis.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen06.png"),
          name: "LANGKAH 6 LIHAT TAGIHAN",
          information: "Tekan Lihat Tagihan untuk melanjutkan.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen07.png"),
          name: "LANGKAH 7 KONFIRMASI",
          information: "Harap periksa dan konfirmasi detail pembayaran.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen08.png"),
          name: "LANGKAH 8 PEMBAYARAN",
          information: "Setelah melakukan konfirmasi, pilih metode pembayaran.",
        },
        {
          copy: false,
          image: require("../../assets/images/idnassets/shopee/shopee_screen09.png"),
          name: "LANGKAH 9 SELESAI",
          information:
            "Pembayaran Selesai. Pengguna dapat melihat detail transaksi.",
        },
      ],
    },
  ];
  function numberOnly(str: any) {
    return String(str).replace(/[^0-9.]/g, "");
  }
  const [selectedData, setSelectedData] = useState<any>({});
  const [dataTemp, setDatatemp] = useState({
    label: "",
    icon: "",
    accountName: "",
    bankAdmin: 0,
    accountNumber: 0,
  });
  const responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024,
      },
      items: 4,
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0,
      },
      items: 1,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464,
      },
      items: 2,
      partialVisibilityGutter: 30,
    },
  };
  const openView = (e: any) => {
    setImagePreview(e);
    setopenPreview(true);
  };
  const getById = (e: any) => {
    console.log(e.label);
    if (e.label == "BNI") {
      setMenua(!menua);
      setMenub(false);
      setMenuc(false);
      setMenud(false);
      setMenue(false);
    } else if (e.label == "BSI") {
      setMenub(!menub);
      setMenua(false);
      setMenuc(false);
      setMenud(false);
      setMenue(false);
    } else if (e.label == "Bank Jatim") {
      setMenuc(!menuc);
      setMenua(false);
      setMenub(false);
      setMenud(false);
      setMenue(false);
    } else if (e.label == "Bank NTB") {
      setMenud(!menud);
      setMenua(false);
      setMenub(false);
      setMenuc(false);
      setMenue(false);
    } else if (e.label == "Permata Bank Syariah") {
      setMenue(!menue);
      setMenua(false);
      setMenub(false);
      setMenuc(false);
      setMenud(false);
    } else {
      setMenua(false);
      setMenub(false);
      setMenuc(false);
      setMenud(false);
      setMenue(false);
    }
    setDatatemp({
      label: e.label,
      icon: e.icon,
      accountName: e.accountName,
      bankAdmin: e.bankAdmin,
      accountNumber: e.accountNumber,
    });
  };

  const [dataVA, setDataVA] = useState<any>([]);
  const [va, setVa] = useState<any>({});
  const navigate = useNavigate();
  const dataBank = [
    {
      initial: "TKI",
      name: "Teknologi Kartu Indonesia",
      adminBank: "",
      icon: tkiLogo,
    },
    {
      initial: "XENDIT BNI",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI OGP",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI 46",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI SYARIAH",
      name: "Bank BNI Syariah",
      adminBank: "",
      icon: bnis,
    },
    {
      initial: "BNI SNAP",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BNI-SNAP",
      name: "Bank Negara Indonesia",
      adminBank: "",
      icon: bni,
    },
    {
      initial: "BANKJATIM",
      name: "Bank Jatim Syariah",
      adminBank: "",
      icon: bjs,
    },
    {
      initial: "BANKJATIM OVERBOOK",
      name: "Bank Jatim Syariah",
      adminBank: "",
      icon: bjs,
    },
    {
      initial: "KBBS",
      name: "KB Bank Syariah",
      adminBank: "",
      icon: kbbs,
    },
    {
      initial: "XENDIT BSI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "TKIPAYBSI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI-MAKARA",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI-SBI",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "BSI-CMS",
      name: "Bank Syariah Indonesia",
      adminBank: "",
      icon: bsi,
    },
    {
      initial: "NTB SYARIAH",
      name: "Bank Ntb Syariah",
      adminBank: "",
      icon: bankntbsy,
    },
    {
      initial: "MUAMALAT",
      name: "Bank Muamalat",
      adminBank: "",
      icon: muamalat,
    },
    {
      initial: "XENDIT BCA",
      name: "Bank Central Asia",
      adminBank: "",
      icon: bca,
    },
    {
      initial: "BCA",
      name: "Bank Central Asia",
      adminBank: "",
      icon: bca,
    },
    {
      initial: "XENDIT BRI",
      name: "Bank Rakyat Indonesia",
      adminBank: "",
      icon: bri,
    },
    {
      initial: "XENDIT MANDIRI",
      name: "Bank Mandiri",
      adminBank: "",
      icon: mandiri,
    },
    {
      initial: "MANDIRI",
      name: "Bank Mandiri",
      adminBank: "",
      icon: mandiri,
    },
    {
      initial: "XENDIT PERMATA",
      name: "Bank Permata",
      adminBank: "",
      icon: permata,
    },
    {
      initial: "PERMATA SYARIAH",
      name: "Bank Permata Syariah",
      adminBank: "",
      icon: permata,
    },
    {
      initial: "BTN",
      name: "Bank Tabungan Negara",
      adminBank: "",
      icon: btpn,
    },
    {
      initial: "XENDIT BJB",
      name: "Bank BJB",
      adminBank: "",
      icon: bjb,
    },
    {
      initial: "BTPN",
      name: "Bank BTPN",
      adminBank: "",
      icon: btpn,
    },
    {
      initial: "XENDIT CIMB",
      name: "Bank CIMB Niaga",
      adminBank: "",
      icon: cimb,
    },
    {
      initial: "PRISMALINK CIMB",
      name: "Bank CIMB Syariah",
      adminBank: "",
      icon: cimbsyariah,
    },
    {
      initial: "DANAMON",
      name: "Bank Danamon",
      adminBank: "",
      icon: danamon,
    },
    {
      initial: "MAYBANK",
      name: "Bank Maybank",
      adminBank: "",
      icon: maybank,
    },
    {
      initial: "OCBC",
      name: "Bank OCBC NISP",
      adminBank: "",
      icon: ocbc,
    },
    {
      initial: "XENDIT DISBURSEMENT",
      name: "Xendit DISBURSEMENT",
      adminBank: "",
      icon: xendit,
    },
    {
      initial: "BRI",
      name: "Bank Rakyat Indonesia",
      adminBank: "",
      icon: bri,
    },
    {
      initial: "BJB SYARIAH",
      name: "Bank BJB Syariah",
      adminBank: "",
      icon: bjbs,
    },
    {
      initial: "SUMSELBABEL",
      name: "Bank Sumsel Babel Syariah",
      adminBank: "",
      icon: bsbs,
    },
    {
      initial: "SUMSELBABEL SYARIAH",
      name: "Bank Sumsel Babel Syariah",
      adminBank: "",
      icon: bsbs,
    },
    {
      initial: "NOBU",
      name: "Bank Nobu",
      adminBank: "",
      icon: nobu,
    },
  ];
  const createVA = async () => {
    createVa(selectedData.bankName)
      .then((res: any) => {
        let cekk = {
          bankName: res.data.bankName || "",
          number: res.data.vaNumber || "",
        };
        setData(cekk);
        console.log(cekk, "data");

        // getVa("create");
        setIsOpen(false);
        setMenua(true);
        toast(t("OTHER.success"));
      })
      .catch((err: any) => {
        // toast.error(t('OTHER.fail'));
        setMenua(false);
        setIsOpen(false);
      });
  };

  const tutorial = async (data: any) => {
    var cek = JSON.stringify(data);
    setTutor(data);
    navigate("/topup-tutorial", {
      state: {
        data: va,
        va: va.vaNumber,
      },
    });
    console.log(cek, "tes");
  };

  function onDismiss() {
    setOpen(false);
  }

  const closeCreate = async () => {
    setIsOpen(false);
    setTempMetode({});
    setOpenInput(false);
    setIdnVa({});
    setSuccesCreate(false);
    setAmount(0);
  };
  const closeImage = async () => {
    setopenPreview(false);
  };
  const getVa = async (type: string) => {
    getAllCreatedVa().then((res) => {
      if (type == "create") {
        //kurang isi nama,belum keluar
        const userTemp = JSON.parse(String(localStorage.getItem("user_redux")));
        userTemp.accounts[0].vaNumbers = res.data.vaNumbers;
        console.log("usert", res.data.vaNumbers);
        dispatch(setUser(userTemp));
        setVa(res.data.vaNumbers);
        setData(res.data.vaNumbers[0]);
      }
    });
  };

  const setVas = async (data: any) => {
    setMenua(false);
    setSelectedData(data);
    console.log(user.accounts[0], data, " cek");
    var temp = user.accounts.length
      ? _.find(user.accounts[0].vaNumbers, {
          bankName: data.bankName,
        })
      : {};
    setVa("");
    if (temp == undefined) {
      setIsOpen(true);
    } else {
      data["vaNumber"] = temp.number;
      data["adminBank"] = temp.adminBank;
      setVa(data);
      setMenua(true);
    }
    // console.log(data, "testes");
  };
  const getIconVa = async (initial: any) => {
    var temp = _.find(dataBank, { initial: initial });
    let result: String = (await temp?.icon) as String;
    return result;
  };
  const getNameVa = async (initial: any) => {
    var temp = _.find(dataBank, { initial: initial });
  };
  function handleSubmit() {
    if (amount <= 9999) {
      return setErrAmount("Input minimal Rp 10.000");
    }
    let query = {
      amount: amount,
    };
    paymentIdn(query)
      .then((resp) => {
        console.log(resp.data);
        setIdnVa(resp.data);
        setSuccesCreate(!succesCreate);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    let tempVA: any[] = [];

    for (var i = 0; i < company.banks.length; i++) {
      var bank = company?.banks[i];

      if (bank == "IDN") {
        //jika idn
        setIdn(true);
      }
      var temp = _.find(dataBank, {
        initial: bank,
      });
      var userBank = user.accounts.length
        ? _.find(user.accounts[0].vaNumbers, {
            bankName: bank,
          })
        : {};

      if (temp) {
        tempVA.push({
          bankName: bank,
          icon: getBankDisplayIcon(bank, temp?.icon),
          name: getBankDisplayName(bank, temp?.name),
          userName: user?.name,
          vaNumber: userBank?.number,
          originalName: temp?.name,
        });
      }
    }

    setDataVA(sortTopupBanks(tempVA));
    getVa("create");
  }, []);

  return (
    <div className="bg-psp-primary mb-8 font-montserrat">
      {/* <Carousal /> */}
      <Stats />
      <div className="h-auto flex bg-psp-primary">
        <div className="container -mt-10 flex  mb-20">
          <div className="flex flex-col rounded-2xl items-center py-2 shadow-lg px-8 bg-white w-2/5">
            <div className="flex w-full mb-8">
              <button
                onClick={() => {
                  navigate(-1);
                }}
                className="h-auto w-auto px-3 py-2 bg-white rounded-lg justify-center items-center mr-2"
              >
                <FontAwesomeIcon
                  size="1x"
                  icon={faChevronLeft}
                  className=" cursor-pointer"
                />
              </button>
              <div className="text-2xl py-2 font-semibold">
                {t("TOPUP.method")}
              </div>
            </div>
            {dataVA.map((item: any, index: any) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    setVas(item);
                    // }
                  }}
                  className="flex rounded-xl border py-3 pl-5 w-full mb-8"
                  style={{ borderColor: "#B2B4C3" }}
                >
                  <img src={item.icon} alt="" className="w-auto max-h-5" />
                  <div className="flex flex-col justify-center ml-8 w-2/3 ">
                    <h1 className="text-xl font-light  text-left">
                      {item.name}
                    </h1>
                  </div>
                </button>
              );
            })}
            {idn && (
              <>
                <h1 className="font-semibold  text-2xl my-4 text-left w-full">
                  {t("TOPUP.otherMetode")}
                </h1>
                {topUpIdn.map((item: any) => (
                  <div
                    onClick={() => {
                      setTempMetode(item);
                      setOpenInput(true);
                    }}
                    className="grid grid-cols-3 my-2 cursor-pointer border bg-white p-3 rounded-xl gap-4 items-center"
                  >
                    <img className=" w-3/4 object-contain" src={item.image} />
                    <h1 className=" m-0 col-span-2 text-xs font-normal font-montserrat">
                      {item.name}
                    </h1>
                  </div>
                ))}
              </>
            )}
            {/* <div className="rounded-xl px-2 w-full mb-8">
              <h5>{t("TOPUP.otherMethod")}</h5>
              <div className="mt-3">
                <select className="w-full py-3 px-3 rounded-lg" disabled>
                  <option>{t("TOPUP.chooseOtherMethod")}</option>
                  <option>Metode 1</option>
                </select>
              </div>
            </div> */}
          </div>

          {menua ? (
            <div
              style={{
                position: "relative",
                zIndex: 1,
                opacity: !menua ? "0" : "1",
                transition: "0.7s",
                visibility: !menua ? "hidden" : "visible",
              }}
              className="flex flex-col rounded-2xl bg-white items-center py-2 w-3/5 shadow-lg ml-5 "
            >
              <div className="flex py-2  px-2 w-full">
                <div className="flex w-full mb-3 flex-col ml-8 gap-3">
                  <img src={selectedData.icon} alt="" className="w-24 h-auto" />
                  <h1 className="my-3 text-2xl">{t("TOPUP.accData")}</h1>
                  <div
                    className="flex flex-row w-full"
                    style={{
                      transition: " 3.0s ",
                    }}
                  >
                    <span className="w-1/4" style={{ color: "gray" }}>
                      {t("TOPUP.bankName")}{" "}
                    </span>
                    <span className="w-3/4">: {selectedData?.name}</span>
                  </div>
                  <div
                    className="flex flex-row w-full"
                    style={{
                      transition: " 1.4s ",
                    }}
                  >
                    <span className="w-1/4" style={{ color: "gray" }}>
                      {t("TOPUP.accName")}{" "}
                    </span>
                    <span className="w-3/4">: {selectedData?.userName}</span>
                  </div>
                  <div
                    className="flex flex-row w-full"
                    style={{
                      transition: " 1.8s ",
                    }}
                  >
                    <span className="w-1/4" style={{ color: "gray" }}>
                      {t("TOPUP.bankAdmin")}{" "}
                    </span>
                    <span className="w-3/4">
                      {": "}
                      {formatCurrency(selectedData?.adminBank)}
                    </span>
                  </div>
                  <div
                    className="flex flex-row w-full "
                    style={{
                      transition: " 2s",
                    }}
                  >
                    <span className="w-1/4" style={{ color: "gray" }}>
                      {t("TOPUP.accNumber")}{" "}
                    </span>
                    <span className="w-3/4   text-blue-500">
                      : {selectedData?.vaNumber}
                    </span>
                  </div>
                </div>
              </div>
              <div className={`${"flex w-full h-14 flex-row justify-center"}`}>
                <div className="border-2 mb-4 border-blue-500 cursor-pointer justify-center items-center  h-auto w-2/4 absolute rounded-lg hover:bg-psp-btn-primary hover:text-white transition">
                  <button
                    onClick={() => tutorial(selectedData)}
                    className="py-2 w-full font-normal font-montserrat text-center h-full relative flex flex-row justify-center items-center text-blue-500 hover:text-white"
                  >
                    {t("TOPUP.tutorial")}
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeCreate}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("TOPUP.popupTitle")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("TOPUP.popupDesc1") +
                        selectedData?.name +
                        " " +
                        t("TOPUP.popupDesc2")}
                    </p>
                  </div>

                  <div className="mt-4 flex gap-2">
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium 
                      ${
                        isDarkColor(customApp?.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => createVA()}
                    >
                      {t("TOPUP.createAccount")}
                    </button>
                    <button
                      type="button"
                      style={{
                        backgroundColor: customApp?.app_secondary_accent_color,
                      }}
                      className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium 
                      ${
                        isDarkColor(customApp?.app_secondary_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                      onClick={() => closeCreate()}
                    >
                      {t("TOPUP.cancel")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={openInputAmount} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10 w-full "
          onClose={closeCreate}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-5xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <button
                    className="absolute top-0 right-2 p-2 text-gray-300 cursor-pointer text-2xl "
                    onClick={() => {
                      setOpenInput(false);
                      setSuccesCreate(false);
                      setTempMetode({});
                      setErrAmount("");
                      setIdnVa({});
                      setAmount(0);
                    }}
                  >
                    x
                  </button>
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {"Top Up Merchant"}
                  </Dialog.Title>
                  <div className="mt-2">
                    <img
                      className=" w-1/4 object-contain"
                      src={tempMetode?.image}
                    />
                    {!succesCreate ? (
                      <>
                        <Dialog.Title
                          as="h3"
                          className="text-base font-medium leading-6 text-gray-500"
                        >
                          {"Masukkan Jumlah"}
                        </Dialog.Title>
                        <CurrencyInput
                          className="px-3 w-full mb-2 rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
                          placeholder="Rp.10.000"
                          decimalsLimit={2}
                          prefix={"Rp "}
                          value={numberOnly(amount)}
                          onValueChange={(value, name) => {
                            setAmount(value != undefined ? Number(value) : 0);
                            setErrAmount("");
                          }}
                        />
                        <p className="text-red italic">{errAmount}</p>
                      </>
                    ) : (
                      <div className="border-b-2">
                        <div>
                          <span className="font-semibold text-gray-400">
                            {"Nama Sekolah"}
                          </span>
                          <p>{idnVa?.companyName}</p>
                        </div>
                        <div className="my-1">
                          <span className="font-semibold text-gray-400">
                            {"NIS"}
                          </span>
                          <p>{idnVa.accountNumber}</p>
                        </div>
                        <div>
                          <span className="font-semibold text-gray-400">
                            {"Jumlah Topup"}
                          </span>
                          <p>{formatCurrency(amount)}</p>
                        </div>
                      </div>
                    )}
                  </div>
                  {succesCreate &&
                    tempMetode?.children?.map((item: any, ind: any) => (
                      <div
                        key={ind}
                        className="flex flex-row justify-between my-2"
                      >
                        <div className="w-10/12">
                          <span>{item?.name}</span>
                          <p>{item?.information}</p>
                        </div>
                        <div className="w-2/12 h-auto">
                          <img
                            onClick={() => openView(item?.image)}
                            className="cursor-pointer w-full object-contain justify-center items-center"
                            src={item?.image}
                          />
                        </div>
                      </div>
                    ))}
                  <div className="mt-4 flex gap-2">
                    {!succesCreate && (
                      <button
                        type="button"
                        style={{
                          backgroundColor: customApp?.app_accent_color,
                        }}
                        className={`inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        {"Proses"}
                      </button>
                    )}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <Transition appear show={openPreview} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={closeImage}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <button
                    className="absolute top-0 right-2 p-2 text-gray-300 cursor-pointer text-2xl "
                    onClick={closeImage}
                  >
                    x
                  </button>
                  <div className="h-auto w-auto">
                    <img
                      className=" w-full object-contain"
                      src={imagePreview}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default ComponentTopupWeb;
